'use client'
import { useTranslations } from 'next-intl'
import SignUp from './SignUp'
import LogIn from './LogIn'
import Bookings from './Bookings'
import Payments from './Payments'
import Account from './Account'
import Support from './Support'

const DetailsSection = () => {
  const t = useTranslations('faqPage.details-page')
  return (
    <div className='leading-[1.5]'>
      <div id='signUp' className='md:mt-[82px] main'>
        <SignUp t={t} />
      </div>
      <div id='logIn' className='mt-[82px] main'>
        <LogIn t={t} />
      </div>
      <div id='bookings' className='mt-[82px] main'>
        <Bookings t={t} />
      </div>
      <div id='payments' className='mt-[82px] main'>
        <Payments t={t} />
      </div>
      <div id='account' className='mt-[82px] main'>
        <Account t={t} />
      </div>
      <div id='support' className='mt-[82px] main'>
        <Support t={t} />
      </div>
    </div>
  )
}

export default DetailsSection
